import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'
import { COLORS } from '../data/enums'
import Iris from './Iris/Iris'

export default function FaceFeature({
  scaleX,
  scale,
  gradient,
  pupil,
  rotation = 0,
  spacing = 0,
  verticalOffset,
  outline,
  showEyeLiner,
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftPupilTransformOrigin = '17.72 13.95'
  const rightPupilTransformOrigin = '41.72 13.95'

  const leftEyePath =
    'M7.72,15.56s2.15-5.95,9.69-6.25c4.15-.16,8.31,2.14,8.31,2.14,0,0-1.28,6.69-8.31,7.73-6.36,.94-9.69-3.62-9.69-3.62Z'
  const rightEyePath =
    'M51.72,15.56s-2.15-5.95-9.69-6.25c-4.15-.16-8.31,2.14-8.31,2.14,0,0,1.28,6.69,8.31,7.73,6.36,.94,9.69-3.62,9.69-3.62Z'

  return (
    <>
      <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
        {/* LEFT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${-spacing})`} transform-origin={leftPupilTransformOrigin}>
          <g transform={`rotate(${rotation})`} transform-origin="inherit">
            <path className="cls-4" d={leftEyePath} fill={COLORS.WHITE} />
            <Iris
              rotation={-rotation}
              maskPath={leftEyePath}
              gradientId={randomGradientId1}
              transformOrigin={leftPupilTransformOrigin}
            />
            <path
              className="cls-6"
              d="M17.72,16.45c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5-2.5,1.12-2.5,2.5,1.12,2.5,2.5,2.5Z"
              fill={pupil}
            />
            <path
              className="cls-5"
              d="M15.69,19.81c-5.41,0-8.24-3.78-8.37-3.95l-.16-.21,.09-.25c.02-.06,2.35-6.27,10.14-6.58,4.24-.17,8.39,2.1,8.57,2.2l.32,.18-.07,.36c-.01,.07-1.44,7.05-8.73,8.13-.63,.09-1.23,.13-1.8,.13Zm-7.39-4.33c.74,.87,3.79,3.99,9.05,3.21,5.74-.85,7.43-5.6,7.8-6.97-1.05-.52-4.41-2.04-7.71-1.9-6.31,.25-8.64,4.55-9.14,5.66Z"
              fill={outline}
            />
            {showEyeLiner && (
              <path d="M7.16,15.64c2.67-8.19,12.81-8.79,19.12-4.45-1.81-.35-3.58-.68-5.33-.89-5.28-.76-10.36,.93-13.79,5.34h0Z" />
            )}
          </g>
          <path
            className="cls-4"
            d="M19.39,13.1c.46,0,.83-.37,.83-.83s-.37-.83-.83-.83-.83,.37-.83,.83,.37,.83,.83,.83Z"
            fill={COLORS.WHITE}
          />
        </g>
        {/* RIGHT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${spacing})`} transform-origin={rightPupilTransformOrigin}>
          <g transform={`rotate(${-rotation})`} transform-origin="inherit">
            <path className="cls-4" d={rightEyePath} fill={COLORS.WHITE} />
            <Iris
              rotation={rotation}
              maskPath={rightEyePath}
              gradientId={randomGradientId2}
              transformOrigin={rightPupilTransformOrigin}
            />
            <path
              className="cls-6"
              d="M41.72,16.45c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5-2.5,1.12-2.5,2.5,1.12,2.5,2.5,2.5Z"
              fill={pupil}
            />
            <path
              className="cls-5"
              d="M43.76,19.81c-.57,0-1.17-.04-1.8-.13-7.29-1.08-8.71-8.06-8.73-8.13l-.07-.36,.32-.18c.18-.1,4.34-2.36,8.57-2.2,7.79,.3,10.12,6.51,10.14,6.58l.09,.25-.16,.21c-.13,.18-2.96,3.95-8.37,3.95Zm-9.45-8.09c.37,1.37,2.06,6.12,7.8,6.97,5.21,.77,8.31-2.35,9.04-3.21-.5-1.12-2.83-5.42-9.14-5.66-3.3-.14-6.66,1.38-7.71,1.9Z"
              fill={outline}
            />
            {showEyeLiner && (
              <path d="M33.17,11.18c6.01-4.72,16.44-3.25,19.12,4.45-5.14-7.02-11.7-5.62-19.12-4.45h0Z" />
            )}
          </g>
          <path
            className="cls-4"
            d="M43.39,13.1c.46,0,.83-.37,.83-.83s-.37-.83-.83-.83-.83,.37-.83,.83,.37,.83,.83,.83Z"
            fill={COLORS.WHITE}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clippath">
          <rect className="cls-1" x="7.72" y="9.3" width="18" height="10" />
        </clipPath>
        <linearGradient
          id={randomGradientId1}
          x1="17.72"
          y1="112.1"
          x2="17.72"
          y2="121.55"
          gradientTransform="translate(0 131.24) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          x1="41.72"
          y1="112.11"
          x2="41.72"
          y2="121.41"
          gradientTransform="translate(0 131.24) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </>
  )
}
